import { Box } from "@mui/material";

import logoUrl from "@/assets/svg/logo.svg";

/**
 * 公司標誌。
 *
 * 刻意不加白底磚、不套濾鏡、不改顏色 —— 標誌的品牌色（紅 #EC0012）是識別
 * 的一部分，換成其他顏色或加上深淺處理就不是同一個標誌了。
 *
 * 深色模式也直接用原色：紅對深色底（#16181D）的對比約 3.9:1，本來就超過
 * 一般非文字元素的 3:1 門檻，就算哪天換一版對比較低的圖，WCAG 1.4.11 也
 * 明確把商標排除在對比門檻之外，不需要為了過測試而回頭改標誌的顏色。
 *
 * 用 `<img>` 而不是把 SVG 內嵌成 React 元件：這樣標誌只有一份檔案，設計端
 * 換圖時不用改程式。檔案約 1.3 KB，低於 Vite 的 assetsInlineLimit（4 KB），
 * 所以 build 後會被內嵌成 data URI —— 少一個請求，但也就沒有獨立快取，
 * 換更大的圖檔時它會自動變回獨立檔案。
 *
 * 代價是不能用 currentColor 控色 —— 但依上面的理由，我們本來就不該控它的色。
 */
interface BrandMarkProps {
  /** 高度（px）。寬度依原始比例（1:1）自動決定 */
  size?: number;
  /**
   * 替代文字。
   *
   * 預設空字串 = 裝飾性，讀螢幕軟體會跳過 —— 旁邊已經有「平台」這種
   * 文字標題的地方就該用預設值，否則使用者會連續聽到兩次同樣的資訊。
   * 標誌是該處**唯一**的識別資訊時（例如登入頁）才傳入文字。
   */
  alt?: string;
}

export function BrandMark({ size = 36, alt = "" }: BrandMarkProps) {
  return (
    <Box
      component="img"
      src={logoUrl}
      alt={alt}
      sx={{ height: size, width: "auto", flex: "none", display: "block" }}
    />
  );
}
